import { useState } from "react";
import { createBrowserHistory } from "history";
import { toast } from "react-hot-toast";
import { Tooltip } from 'react-tooltip';
import { ButtonLoader } from "../_components/Loader";
import { isString } from "lodash";
import * as XLSX from "xlsx";
import JsonData from "../_assets/Data.json";

export const isAuthorized = (userRole, authorizedRoles) => {
  return generateRoles(userRole).some((role) => authorizedRoles.includes(role));
};

export const generateRoles = (userRoles) => {
  return Object.entries(
    Object.freeze({
      Admin: 1,
      Student: 2,
      Institute: 3,
      Instructor: 4,
      Parent: 5,
    })
  )
    .filter(([key, value]) => userRoles.includes(value))
    .map(([key, value]) => key);
};

export const history = createBrowserHistory();

export const filterActiveData = (data) => {
  if (data?.length > 0) {
    return data?.filter((obj) => obj?.isActive);
  } else {
    return []
  }
};

export const customToast = (msg) => {
  toast.custom(
    <div
      style={{
        fontSize: "17px",
        border: "2px solid #DE0000",
        margin: "70px",
        padding: "5px 50px",
        color: "#fff",
        backgroundColor: "#DE0000",
        borderRadius: "5px",
      }}
    >
      {msg}
    </div>
  );
};

export const successToast = (msg) => {
  toast.success(msg, {
    duration: 3000,
    iconTheme: {
      primary: "green",
      secondary: "white",
    },
    role: "status",
    ariaLive: "polite",
    style: {
      background: "#00BF26",
      color: "white",
    },
    // icon: <AiFillAndroid />
  });
  // toast.success(
  //   <div className="toast-success">
  //     <h3 className="toast-success-title">{msg}</h3>
  //   </div>,
  //   {
  //     duration: 3000,
  //     iconTheme: {
  //       primary: 'green',
  //       secondary: 'white',
  //     },
  //     role: "status",
  //     ariaLive: "polite",
  //     style: {
  //       background: "white",
  //       color: "black"
  //     },
  //     // icon: <AiFillAndroid />
  //   });
};

export const errorToast = (msg) => {
  toast.error(msg, {
    duration: 3000,
    iconTheme: {
      primary: "#fff",
      secondary: "red",
    },
    role: "status",
    ariaLive: "polite",
    style: {
      background: "red",
      color: "whitesmoke",
      // marginTop: 75
    },
    // icon: <AiFillAndroid />
  });
};

export const truncateString = (text, length) => {
  let maxLength = length ? length : 20;

  if (text && isString(text)) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength) + '...';
  } else {
    return text;
  }
}

export const nl2brFunction = (text) => {

  return text.replaceAll(',', '<br/>');

}



export const sapCode = (text) => {
  let sap1 = "";
  if (text) {
    sap1 = ' (' + text + ')';
  }
  return sap1;
}



export const infoToast = (msg) => {
  toast.success(msg, {
    duration: 3000,
    iconTheme: {
      primary: "#0a58ca",
      secondary: "white",
    },
    role: "status",
    ariaLive: "polite",
    style: {
      background: "#00d4ff",
      color: "white",
    },
    // icon: <AiFillAndroid />
  });

};

// MultiStepForm Function
// Form Component
export const MultiStepFormComp = ({ id = "", children, ...props }) => {
  return (
    <form id={id} {...props}>
      {children}
    </form>
  );
};

// A hook that accept a array of components (setps)
// return the all functionality of the multi step form
export const useMultiStepForm = (steps, MainComp = "", checkCome = "", avgDiscountFunc = {}, FelidValCheck = false, InputArrayCheck = [], focDecreaseStep = false) => {
  // console.log("InputArrayCheck:", InputArrayCheck)
  // console.log("InputArrayCheck condition:", InputArrayCheck === 0 || InputArrayCheck.length === 0 || InputArrayCheck.length < 0)
  // States
  const [currentStep, setCurrentStep] = useState(0);

  // Get the next step from the array
  const next = () => {



    if (MainComp === "Quotation" && currentStep === 1) {
      if (checkCome === "discPer") {
        avgDiscountFunc()
        if (FelidValCheck) {
          return null;
        }
      }
      if (InputArrayCheck === 0 || InputArrayCheck.length === 0 || InputArrayCheck.length < 0) {
        errorToast('Please Add Line Items')
        return null;
      }
    }

    if (MainComp === "FOC" && focDecreaseStep && currentStep === 1) {
      if (checkCome === "PartsDetail") {
        if (InputArrayCheck === 0 || InputArrayCheck.length === 0 || InputArrayCheck.length < 0) {
          errorToast('Please Add Parts Detail')
          return null;
        }
        if (FelidValCheck === 0 || FelidValCheck < 0) {
          errorToast('Please Add Proper Data')
          return null;
        }
      }
    } else if (MainComp === "FOC" && currentStep === 2) {
      if (checkCome === "PartsDetail") {
        if (InputArrayCheck === 0 || InputArrayCheck.length === 0 || InputArrayCheck.length < 0) {
          errorToast('Please Add Parts Detail')
          return null;
        }
        if (FelidValCheck === 0 || FelidValCheck < 0) {
          errorToast('Please Add Proper Data')
          return null;
        }
      }
    }

    if (MainComp === "Customer" && currentStep === 1) {
      if (checkCome === "Contact Detail") {
        //console.log(InputArrayCheck);
        if (InputArrayCheck === 0 || InputArrayCheck.length === 0 || InputArrayCheck.length < 0) {
          errorToast('Please Add Contact Detail')
          return null;
        }
        if (FelidValCheck === 0 || FelidValCheck < 0) {
          errorToast('Please Add Proper Data')
          return null;
        }
      }
    }

    setCurrentStep((prev) => {
      if (prev < steps.length - 1) return prev + 1;
      return prev;
    });
  };

  // Get the previous step in the steps array
  const back = () => {
    setCurrentStep((prev) => {
      if (prev > 0) return prev - 1;
      return prev;
    });
  };

  // Go to any step
  const goTo = (index) => {
    setCurrentStep(index);
  };

  return {
    next,
    back,
    goTo,
    Step: steps[currentStep],
    currentStep,
    isLastStep: currentStep === steps.length - 1,
    isFirstStep: currentStep === 0,
  };
};

// Form Controllers Component
export const MultiStepsControllers = ({
  back,
  isFirstStep,
  isLastStep,
  handleFinish,
  submitLoader = false,
  hideButton = false,
}) => {
  return (
    <div className="form-controllers">
      <Tooltip
        place="bottom"
        className="tool_tip_graph"
        anchorId="Previous"
      />
      <Tooltip
        place="bottom"
        className="tool_tip_graph"
        anchorId="Next"
      />
      <button data-tooltip-content="Previous" id="Previous" onClick={back} disabled={isFirstStep} className="right_bt">
        <i class="fas fa-chevron-left"></i>
      </button>

      {isLastStep ? !submitLoader ?
        (!hideButton && <button class="btn btn-primary px-4 ms-3" form="customer" type="submit">
          Submit
        </button>) :
        <button class="btn btn-primary px-4 ms-3" form="customer" type="submit">
          <ButtonLoader />
        </button> : (
        <button data-tooltip-content="Next" id="Next" form="customer" type="submit" className="right_bt">
          <i class="fas fa-chevron-right"></i>
        </button>
      )}
      {/* <button
        form="customer" 
        type="submit"
      // onClick={isLastStep ? handleFinish : null}
      >
        {isLastStep ? 'Submit' : <i class="fas fa-chevron-right"></i>}
      </button> */}
    </div>
  );
};



export const getSumOfArrayOfObjects = (arr, keyToBindValue, seedingCurrencyTypeVal) => {
  if (keyToBindValue === "discountPercentage") {
    let temp = null;
    temp = (arr || []).reduce(
      (acc, curr) =>
        (Number(acc) || 0) +
        (Number(curr[keyToBindValue]) || 0),
      0
    )
    return temp.toFixed(2);
  } else {
    if (seedingCurrencyTypeVal === "INR" || seedingCurrencyTypeVal === "USD") {
      //   return (arr || []).reduce(
      //     (acc, curr) =>
      //       (Number(acc) || 0) +
      //       (Number(Math.round(curr[keyToBindValue])) || 0),
      //     0
      //   )
      // } else if (seedingCurrencyTypeVal === "USD") {
      let temp = null;
      temp = (arr || []).reduce(
        (acc, curr) =>
          (Number(acc) || 0) +
          (Number(curr[keyToBindValue]) || 0),
        0
      )
      return temp.toFixed(2);
    } else {
      let temp = null;
      temp = (arr || []).reduce(
        (acc, curr) =>
          (Number(acc) || 0) +
          (Number(curr[keyToBindValue]) || 0),
        0
      )
      return temp.toFixed(2);
    }
  }
}


export const getCalculation = (arr, index) => {
  // console.log("🚀 ~ file: utilities.js:193 ~ getCalculation ~ arr:", arr)

  let price = arr[index]?.price ? arr[index]?.price : 0
  let quantity = arr[index]?.quantity ? arr[index]?.quantity : 0
  let discountPercentage = arr[index]?.discountPercentage ? arr[index]?.discountPercentage : 0

  let total = price * quantity
  let withDiscount = (total * discountPercentage) / 100
  return (total - withDiscount)
}


export const getCalculationUnitRate = (arr, index, ChargeValObj, seedingCurrencyTypeVal, comeFrom) => {

  // console.log("seedingCurrencyTypeVal === EURO:", seedingCurrencyTypeVal === "EURO")


  // "euroQuartleyValue"  euro
  // "euroPPValue"        euroPP
  // "euroRegularValue"   dollar


  let SurChargeValue = ChargeValObj?.SurChargeVal ? ChargeValObj?.SurChargeVal : 0
  let euroQuartleyValue = ChargeValObj?.euroQuartley ? ChargeValObj?.euroQuartley : 0
  let euroPPValue = ChargeValObj?.euroPP ? ChargeValObj?.euroPP : 0
  let euroRegularValue = ChargeValObj?.euroRegular ? ChargeValObj?.euroRegular : 0
  let lineOfItemRateValue = ChargeValObj?.lineOfItemRate ? ChargeValObj?.lineOfItemRate : 1


  // console.log("🚀 ~ file: utilities.js:204 ~ SurChargeValue:", SurChargeValue)



  let lpEuro = arr[index]?.lpEuro ? arr[index]?.lpEuro : 0
  lpEuro = lpEuro * lineOfItemRateValue

  let quantity = arr[index]?.quantity ? arr[index]?.quantity : 0
  let seedingOrderTypeValue = arr[index]?.seedingOrderTypeValue ? arr[index]?.seedingOrderTypeValue : "PP"
  let discountPercentage = arr[index]?.discountPercentage ? arr[index]?.discountPercentage : 0
  let usdPrice = arr[index]?.price ? arr[index]?.price : 0
  let RoundValue = false

  if (comeFrom === "discountPercentage") {
    quantity = 1
  }
  // if (comeFrom === "discountPercentage" && seedingCurrencyTypeVal === "INR") {
  //   RoundValue = true
  // }

  if (comeFrom === "totalLineAmount" && seedingCurrencyTypeVal === "INR") {
    RoundValue = true
  }

  let total = lpEuro * quantity
  let seedingOrderTypeVal = seedingOrderTypeValue

  if (seedingCurrencyTypeVal === "USD") {
    // total = usdPrice * quantity
    if (seedingOrderTypeVal === "PP") {
      total = total * euroPPValue
    }
    else if (seedingOrderTypeVal === "SD") {
      total = total * euroQuartleyValue
    }
    else if (seedingOrderTypeVal === "Normal") {
      total = total * euroQuartleyValue
    }
    total = total / euroRegularValue
  } else if (seedingCurrencyTypeVal === "EURO") {
    // total = usdPrice * quantity
    total = total * 1
    // total = total * euroRegularValue
  } else {
    if (seedingOrderTypeVal === "PP") {
      total = total * euroPPValue
    }
    else if (seedingOrderTypeVal === "SD") {
      total = total * euroQuartleyValue
    }
    else if (seedingOrderTypeVal === "Normal") {
      total = total * euroQuartleyValue
    }
  }

  total += ((total * SurChargeValue) / 100)

  let withDiscount = (total * discountPercentage) / 100
  let finalTotal = 0
  // if (lineOfItemRateValue) {
  //   finalTotal = (total - withDiscount) * lineOfItemRateValue
  // } else {
  finalTotal = (total - withDiscount)
  // }


  if (seedingCurrencyTypeVal === "USD") {
    return (finalTotal).toFixed(2)
  } else if (seedingCurrencyTypeVal === "EURO") {
    return (finalTotal).toFixed(2)
  } else {
    if (RoundValue) {
      return Math.round(finalTotal)
    } else {
      return (finalTotal).toFixed(2)
    }
  }

}

export const getCalculationToAll = (event, arr, key, currencyType, selectDropDown, ChargeValObj) => {
  // console.log("event.target.value", event.target.value)

  //console.log(arr)
  // "euroQuartleyValue"  euro
  // "euroPPValue"        euroPP
  // "euroRegularValue"   dollar
  let SurChargeValue = null
  let euroQuartleyValue = null
  let euroPPValue = null
  let euroRegularValue = null


  if (currencyType === "EURO") {
    SurChargeValue = ChargeValObj?.SurChargeVal ? ChargeValObj?.SurChargeVal : 0
    euroQuartleyValue = 1
    euroPPValue = 1
    euroRegularValue = 1
  } else {
    SurChargeValue = ChargeValObj?.SurChargeVal ? ChargeValObj?.SurChargeVal : 0
    euroQuartleyValue = ChargeValObj?.euroQuartley ? ChargeValObj?.euroQuartley : 0
    euroPPValue = ChargeValObj?.euroPP ? ChargeValObj?.euroPP : 0
    euroRegularValue = ChargeValObj?.euroRegular ? ChargeValObj?.euroRegular : 0
  }





  let inputValue;
  if (key === "uom") {
    inputValue = event.target.value
  } else if (key === "discountPercentage") {
    inputValue = event.target.value === "" ? 0 : parseFloat(event.target.value).toFixed(2)
  } else {
    inputValue = parseInt(event.target.value) > 0 ? parseInt(event.target.value) : 0
  }
  let newVal = []


  if (arr?.length > 0) {
    if (selectDropDown) {
      if (currencyType === "USD") {


        newVal = arr.map((item) => {

          let seedingOrderTypeVal = item?.seedingOrderTypeValue ? item?.seedingOrderTypeValue : "PP"
          let lpEuro = item?.lpEuro ? item?.lpEuro : 0
          let lineOfItemRateValue = item?.lineOfItemRate ? item?.lineOfItemRate : 1
          lpEuro = lpEuro * lineOfItemRateValue

          let quantity = item?.quantity ? item?.quantity : 0
          // let discountPercentage = inputValue
          let discountPercentage = item?.discountPercentage ? item?.discountPercentage : 0

          let priceTotal = lpEuro * 1
          let total = lpEuro * quantity


          if (seedingOrderTypeVal === "PP") {
            // console.log("PP:", seedingOrderTypeVal)
            priceTotal = priceTotal * euroPPValue
            total = total * euroPPValue
          }
          else if (seedingOrderTypeVal === "SD") {
            // console.log("SD:", seedingOrderTypeVal)
            priceTotal = priceTotal * euroQuartleyValue
            total = total * euroQuartleyValue
          }
          else if (seedingOrderTypeVal === "Normal") {
            // console.log("Normal:", seedingOrderTypeVal)
            priceTotal = priceTotal * euroQuartleyValue
            total = total * euroQuartleyValue
          }

          priceTotal = (priceTotal / euroRegularValue)
          priceTotal += ((priceTotal * SurChargeValue) / 100)
          let priceDiscount = (priceTotal * discountPercentage) / 100


          total = (total / euroRegularValue)
          total += ((total * SurChargeValue) / 100)
          let withDiscount = (total * discountPercentage) / 100



          return ({ ...item, [key]: inputValue, "price": (priceTotal - priceDiscount).toFixed(2), "totalLineAmount": (total - withDiscount).toFixed(2) })
        })


      } else if (currencyType === "EURO") {


        // newVal = arr.map((item) => {


        //   let seedingOrderTypeVal = item?.seedingOrderTypeValue ? item?.seedingOrderTypeValue : "PP"
        //   let lpEuro = item?.lpEuro ? item?.lpEuro : 0
        //   let quantity = item?.quantity ? item?.quantity : 0
        //   let discountPercentage = inputValue

        //   let priceTotal = lpEuro * 1
        //   let total = lpEuro * quantity


        //   if (seedingOrderTypeVal === "PP") {
        //     // console.log("PP:", seedingOrderTypeVal)
        //     priceTotal = priceTotal * euroPPValue
        //     total = total * euroPPValue
        //   }
        //   else if (seedingOrderTypeVal === "SD") {
        //     // console.log("SD:", seedingOrderTypeVal)
        //     priceTotal = priceTotal * euroQuartleyValue
        //     total = total * euroQuartleyValue
        //   }
        //   else if (seedingOrderTypeVal === "Normal") {
        //     // console.log("Normal:", seedingOrderTypeVal)
        //     priceTotal = priceTotal * euroQuartleyValue
        //     total = total * euroQuartleyValue
        //   }

        //   priceTotal = (priceTotal / euroRegularValue)
        //   priceTotal += ((priceTotal * SurChargeValue) / 100)
        //   let priceDiscount = (priceTotal * discountPercentage) / 100


        //   total = (total / euroRegularValue)
        //   total += ((total * SurChargeValue) / 100)
        //   let withDiscount = (total * discountPercentage) / 100



        //   return ({ ...item, [key]: inputValue, "price": (priceTotal - priceDiscount).toFixed(2), "totalLineAmount": (total - withDiscount).toFixed(2) })
        // })

















        newVal = arr.map((item) => {

          let lpEuro = item?.lpEuro ? item?.lpEuro : 0
          let lineOfItemRateValue = item?.lineOfItemRate ? item?.lineOfItemRate : 1
          lpEuro = lpEuro * lineOfItemRateValue
          let quantity = item?.quantity ? item?.quantity : 0
          // let discountPercentage = inputValue
          let discountPercentage = item?.discountPercentage ? item?.discountPercentage : 0

          let priceTotal = lpEuro * 1
          priceTotal = priceTotal * 1
          priceTotal += ((priceTotal * SurChargeValue) / 100)
          let priceDiscount = (priceTotal * discountPercentage) / 100

          let total = lpEuro * quantity
          total = total * 1
          total += ((total * SurChargeValue) / 100)
          let withDiscount = (total * discountPercentage) / 100
          let TotalLineAmount = (total - withDiscount).toFixed(2)
          let TotalPriceAmount = (priceTotal - priceDiscount).toFixed(2)


          return ({ ...item, [key]: inputValue, "price": TotalPriceAmount, "totalLineAmount": TotalLineAmount })
        })
      } else {
        newVal = arr.map((item) => {
          let lpEuro = item?.lpEuro ? item?.lpEuro : 0
          let lineOfItemRateValue = item?.lineOfItemRate ? item?.lineOfItemRate : 1
          lpEuro = lpEuro * lineOfItemRateValue
          let quantity = item?.quantity ? item?.quantity : 0
          let seedingOrderTypeValue = item?.seedingOrderTypeValue ? item?.seedingOrderTypeValue : "PP"
          let discountPercentage = item?.discountPercentage ? item?.discountPercentage : 0

          let priceTotal = lpEuro * 1
          let total = lpEuro * quantity

          let seedingOrderTypeVal = seedingOrderTypeValue


          if (seedingOrderTypeVal === "PP") {
            priceTotal = priceTotal * euroPPValue
            total = total * euroPPValue
          }
          else if (seedingOrderTypeVal === "SD") {
            priceTotal = priceTotal * euroQuartleyValue
            total = total * euroQuartleyValue
          }
          else if (seedingOrderTypeVal === "Normal") {
            priceTotal = priceTotal * euroQuartleyValue
            total = total * euroQuartleyValue
          }
          priceTotal += ((priceTotal * SurChargeValue) / 100)
          total += ((total * SurChargeValue) / 100)

          let priceDiscount = (priceTotal * discountPercentage) / 100
          let withDiscount = (total * discountPercentage) / 100


          let TotalLineAmount = (total - withDiscount).toFixed(2)
          let TotalPriceAmount = (priceTotal - priceDiscount).toFixed(2)


          // let total = item.price * item.quantity
          // let withDiscount = (total * inputValue) / 100

          // old calculation
          // return ({ ...item, [key]: inputValue, "price": Math.round(priceTotal - priceDiscount), "totalLineAmount": Math.round(total - withDiscount) })


          return ({ ...item, [key]: inputValue, "price": TotalPriceAmount, "totalLineAmount": Math.round(total - withDiscount) })

        })


      }
    } else {
      if (key === "discountPercentage") {

        let PPMin = ChargeValObj?.PPMin ? ChargeValObj?.PPMin : 0
        let PPMax = ChargeValObj?.PPMax ? ChargeValObj?.PPMax : 0
        let SDMin = ChargeValObj?.SDMin ? ChargeValObj?.SDMin : 0
        let SDMax = ChargeValObj?.SDMax ? ChargeValObj?.SDMax : 0
        let normalMin = ChargeValObj?.normalMin ? ChargeValObj?.normalMin : 0
        let normalMax = ChargeValObj?.normalMax ? ChargeValObj?.normalMax : 0


        // console.log("input:", inputValue)
        newVal = arr.map((item) => {


          let lpEuro = item?.lpEuro ? item?.lpEuro : 0
          let lineOfItemRateValue = item?.lineOfItemRate ? item?.lineOfItemRate : 1
          lpEuro = lpEuro * lineOfItemRateValue
          let quantity = item?.quantity ? item?.quantity : 0
          let seedingOrderTypeValue = item?.seedingOrderTypeValue ? item?.seedingOrderTypeValue : "PP"
          let discountPercentage = inputValue

          let total = lpEuro * quantity
          let priceTotal = lpEuro * 1

          let seedingOrderTypeVal = seedingOrderTypeValue


          if (seedingOrderTypeVal === "PP") {
            total = total * euroPPValue
            priceTotal = priceTotal * euroPPValue
            if (discountPercentage < PPMin) {
              discountPercentage = PPMin
              inputValue = PPMin
            } else if (discountPercentage > PPMax) {
              discountPercentage = PPMax
              inputValue = PPMax
            }
          }
          else if (seedingOrderTypeVal === "SD") {
            total = total * euroQuartleyValue
            priceTotal = priceTotal * euroQuartleyValue
            if (discountPercentage < SDMin) {
              discountPercentage = SDMin
              inputValue = SDMin
            } else if (discountPercentage > SDMax) {
              discountPercentage = SDMax
              inputValue = SDMax
            }
          }





          else if (seedingOrderTypeVal === "Normal") {
            total = total * euroQuartleyValue
            priceTotal = priceTotal * euroQuartleyValue

            if (discountPercentage < normalMin) {
              discountPercentage = normalMin
              inputValue = normalMin
            } else if (discountPercentage > normalMax) {
              discountPercentage = normalMax
              inputValue = normalMax
            }


          }






          if (currencyType === "USD") {
            priceTotal = (priceTotal / euroRegularValue)
            total = (total / euroRegularValue)
          }

          total += ((total * SurChargeValue) / 100)
          priceTotal += ((priceTotal * SurChargeValue) / 100)
          let withDiscount, priceDiscount, Price, TotalLineAmount;

          if (discountPercentage) {
            withDiscount = (total * discountPercentage) / 100
            priceDiscount = (priceTotal * discountPercentage) / 100
            if (currencyType === "USD") {
              Price = (priceTotal - priceDiscount).toFixed(2)
              TotalLineAmount = (total - withDiscount).toFixed(2)
            } else if (currencyType === "EURO") {
              Price = (priceTotal - priceDiscount).toFixed(2)
              TotalLineAmount = (total - withDiscount).toFixed(2)
            } else {
              // old calculation
              // Price = Math.round(priceTotal - priceDiscount)
              TotalLineAmount = Math.round(total - withDiscount)


              Price = (priceTotal - priceDiscount).toFixed(2)
              // TotalLineAmount = (total - withDiscount).toFixed(2)


            }
          } else {
            if (currencyType === "USD") {
              Price = priceTotal.toFixed(2)
              TotalLineAmount = total.toFixed(2)
            } else if (currencyType === "EURO") {
              Price = priceTotal.toFixed(2)
              TotalLineAmount = total.toFixed(2)
            } else {

              // old calculation
              // Price = Math.round(priceTotal)
              TotalLineAmount = Math.round(total)

              Price = priceTotal.toFixed(2)
              // TotalLineAmount = total.toFixed(2)
            }
          }


          // let total = item.price * item.quantity
          // let withDiscount = (total * inputValue) / 100

          return ({ ...item, [key]: inputValue, "price": Price, "totalLineAmount": TotalLineAmount })
        })



      } else if (key === "quantity") {
        newVal = arr.map((item) => {


          let lpEuro = item?.lpEuro ? item?.lpEuro : 0
          let lineOfItemRateValue = item?.lineOfItemRate ? item?.lineOfItemRate : 1
          lpEuro = lpEuro * lineOfItemRateValue
          let discountPercentage = item?.discountPercentage ? item?.discountPercentage : 0
          let seedingOrderTypeValue = item?.seedingOrderTypeValue ? item?.seedingOrderTypeValue : "PP"
          let quantity = inputValue

          let total = lpEuro * quantity
          let priceTotal = lpEuro * 1

          let seedingOrderTypeVal = seedingOrderTypeValue

          if (seedingOrderTypeVal === "PP") {
            total = total * euroPPValue
            priceTotal = priceTotal * euroPPValue
          }
          else if (seedingOrderTypeVal === "SD") {
            total = total * euroQuartleyValue
            priceTotal = priceTotal * euroQuartleyValue
          }
          else if (seedingOrderTypeVal === "Normal") {
            total = total * euroQuartleyValue
            priceTotal = priceTotal * euroQuartleyValue
          }
          if (currencyType === "USD") {
            priceTotal = (priceTotal / euroRegularValue)
            total = (total / euroRegularValue)
          }

          total += ((total * SurChargeValue) / 100)

          priceTotal += ((priceTotal * SurChargeValue) / 100)

          let withDiscount, priceDiscount, Price, TotalLineAmount;

          withDiscount = (total * discountPercentage) / 100
          priceDiscount = (priceTotal * discountPercentage) / 100

          if (currencyType === "USD") {
            Price = (priceTotal - priceDiscount).toFixed(2)
            TotalLineAmount = (total - withDiscount).toFixed(2)
          } else if (currencyType === "EURO") {
            Price = (priceTotal - priceDiscount).toFixed(2)
            TotalLineAmount = (total - withDiscount).toFixed(2)
          } else {
            // Price = Math.round(priceTotal - priceDiscount)

            Price = (priceTotal - priceDiscount).toFixed(2)
            TotalLineAmount = Math.round(total - withDiscount)
          }

          // let total = item.price * item.quantity
          // let withDiscount = (total * inputValue) / 100
          return ({ ...item, [key]: inputValue, "price": Price, "totalLineAmount": TotalLineAmount })
        })
      } else if (key === "uom") {
        newVal = arr.map((item) => {
          return ({ ...item, [key]: inputValue })
        })
      }
    }
  }
  return newVal
}

export const UploadExcel = (data, fileType, OrderType) => {
  let keyOfArray = [
    "lauffNo",
    "productType",
    "itemDescription",
    "lpEuro",
    "quantity",
    "uom",
    "custMaterialReference",
    "hsnCode",
    "gst",
  ]

  const dataArrayWithKeys = data.map((obj, dataIndex) =>
    // Object.keys(obj).reduce((acc, key, index) => {
    //   let KeyOfArray = keyOfArray[index]
    //   let ValueOfArray = obj[key]
    //   acc[KeyOfArray] = ValueOfArray;
    //   return acc;
    // }, {}));
    Object.keys(obj).reduce((acc, key, index) => {
      // let totalLineAmount = 0
      // if(keyOfArray[index] ===)
      // console.log("obj[key]", keyOfArray[index]);
      acc[keyOfArray[index]] = obj[key];
      return {
        ...acc,
        "itemId": dataIndex + 1,
        "fileType": fileType,
        "seedingOrderTypeValue": OrderType,
        "lineOfItemRate": 1,
        "discountPercentage": null,
      };
    }, {})
  );
  return dataArrayWithKeys
}


export const XMLArray = (data, fileType, OrderType) => {
  let keyOfArray = [
    "productType",
    "itemDescription",
    "lpEuro",
    "quantity",
    "custMaterialReference",
    "hsnCode",
    "gst",
    "fileName",
    "filePath",
    "xmlTechData"
  ]
  let changeRequest = false;
  const dataArrayWithKeys = data.map((obj, dataIndex) =>
    // Object.keys(obj).reduce((acc, key, index) => {
    //   let KeyOfArray = keyOfArray[index]
    //   let ValueOfArray = obj[key]
    //   acc[KeyOfArray] = ValueOfArray;
    //   return acc;
    // }, {}));

    Object.keys(obj).reduce((acc, key, index) => {
      // let totalLineAmount = 0
      // if(keyOfArray[index] ===)
      // console.log("obj[key]", keyOfArray[index]);
      if (keyOfArray[index] === "quantity") {
        acc[keyOfArray[index]] = obj[keyOfArray[index]] > 0 ? obj[keyOfArray[index]] : null;
      } else if (keyOfArray[index] === "lpEuro") {
        changeRequest = obj[keyOfArray[index]] > 0 ? false : true;
        acc[keyOfArray[index]] = obj[keyOfArray[index]];
      } else {
        acc[keyOfArray[index]] = obj[keyOfArray[index]];
      }

      return {
        ...acc,
        "itemId": dataIndex + 1,
        "uom": "PC",
        "fileType": fileType,
        "seedingOrderTypeValue": OrderType,
        "lineOfItemRate": 1,
        "discountPercentage": null,
        "changeRequest": changeRequest

      };
    }, {})
  );
  //console.log("dataArrayWithKeys:", dataArrayWithKeys)
  return dataArrayWithKeys
}



export const spareArray = (data, fileType, OrderType) => {
  let keyOfArray = [
    "productType",
    "itemDescription",
    "lpEuro",
    "quantity",
    "uom",
    "custMaterialReference",
    "hsnCode",
    "gst",
    "xmlTechData",
    "isValid",
    "seedingOrderTypeValue"
  ]

  const dataArrayWithKeys = data.map((obj, dataIndex) =>
    // Object.keys(obj).reduce((acc, key, index) => {
    //   let KeyOfArray = keyOfArray[index]
    //   let ValueOfArray = obj[key]
    //   acc[KeyOfArray] = ValueOfArray;
    //   return acc;
    // }, {}));
    Object.keys(obj).reduce((acc, key, index) => {
      // let totalLineAmount = 0
      // if(keyOfArray[index] ===)

      // console.log("obj[key]", keyOfArray[index]);
      // console.log("obj[isValid]", obj["isValid"]);

      // if Spare InValid
      if (!obj["isValid"]) {
        if (keyOfArray[index] === "quantity") {
          acc[keyOfArray[index]] = obj[keyOfArray[index]] > 0 ? obj[keyOfArray[index]] : null;
        }
        //  else if (keyOfArray[index] === "productType") {
        //   acc[keyOfArray[index]] = "";
        // }
        else if (keyOfArray[index] === "lpEuro") {
          acc[keyOfArray[index]] = null;
        } else {
          acc[keyOfArray[index]] = obj[keyOfArray[index]];
        }
      } else {
        if (keyOfArray[index] === "quantity") {
          acc[keyOfArray[index]] = obj[keyOfArray[index]] > 0 ? obj[keyOfArray[index]] : null;
        } else {
          acc[keyOfArray[index]] = obj[keyOfArray[index]];
        }
      }

      return {
        ...acc,
        "itemId": dataIndex + 1,
        "fileType": fileType,
        "lineOfItemRate": 1,
        "discountPercentage": 0
      };
    }, {})
  );
  return dataArrayWithKeys
}



export const generateSpare = (data, fileType, OrderType) => {
  let keyOfArray = [
    "partNumber",
    "quantity",
    "custMaterialReference"
  ]

  const dataArrayWithKeys = data.map((obj, dataIndex) =>

    Object.keys(obj).reduce((acc, key, index) => {
      if (keyOfArray[index] === "partNumber") {
        let temp = obj[key];

        temp = temp.toString();

        acc[keyOfArray[index]] = temp;
      } else {
        acc[keyOfArray[index]] = obj[key];
      }
      return {
        ...acc,
      };
    }, {})
  );
  return dataArrayWithKeys
}

export const numberOnly = () => {
  return {
    value: /^(0|[1-9]\d*)(\.\d+)?$/,
    message: "Invalid Input.",
  }
}


export const textOnly = () => {
  return {
    value: /^[A-Za-z -]+$/,
    message: "Invalid Input.",
  }
}

export const emailOnly = () => {
  return {
    value: /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/,
    message: "Invalid Input.",
  }
}

export const percentageOnly = () => {
  return {
    value: /^(0|[1-9][0-9]?|100)$/,
    message: "Invalid Input.",
  }
}

export const lineItemCheck = () => {
  return {
    value: /^\d/,
    message: "Invalid Input.",
  }
}

export const PanCheck = () => {
  return {
    value: /^([A-Z]){5}([0-9]){4}([A-Z]){1}?$/,
    message: "Invalid Input.",
  }
}

export const GSTCheck = () => {
  return {
    value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
    message: "Invalid Input.",
  }
}

export const phoneNumberCheck = () => {
  return {
    value: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
    message: "Invalid Input.",
  }
}

export const LengthCheckCheck = (val) => {
  return {
    value: /^[a-zA-Z0-9]{val}$/,
    message: "Invalid Input.",
  }
}

export const checkNullStr = (value) => {
  let newVal = value !== null ? value === "null" ? "" : value : ""
  return newVal
}

export const checkNullNum = (value) => {
  let newVal = value !== null ? value : 0
  return newVal
}

export const getCustomerDetailsFormattedStr = (billingAddress, address2, city, district, state, contactName, contactNumber, contactEmail) => {
  return `${billingAddress}
${address2}
${city}, ${district}, ${state}
${contactName}
${contactNumber}
${contactEmail}`
}

export const getBillToCustomerDetailsFormattedStr = (billToCustomer, branch, salesOffice, partyAddress, sapNo) => {
  return `${billToCustomer}
${branch}
${salesOffice}
${partyAddress}
${sapNo}`
}

export const getShipToCustomerDetailsFormattedStr = (shipToCustomer, branch, salesOffice, partyAddress, sapNo,) => {
  return `${shipToCustomer}
${branch}
${salesOffice}
${partyAddress}
${sapNo}`
}

export const getQuotationCustomerDetailsFormattedStr = (name, phone, email, address) => {
  return `${name}
${phone}
${email}
${address}`
}







// Download Zip
// const binaryString = atob(result?.data);
// const byteNumbers = new Array(binaryString.length);
// for (let i = 0; i < binaryString.length; i++) {
//   byteNumbers[i] = binaryString.charCodeAt(i);
// }
// const byteArray = new Uint8Array(byteNumbers);
// const blob = new Blob([byteArray], { type: "application/zip" });

// const url = URL.createObjectURL(blob);

// const a = document.createElement('a');
// a.href = url;
// a.download = moduleDetails ? moduleDetails : 'decoded-file'; // Specify the desired filename
// document.body.appendChild(a);
// a.click();
// document.body.removeChild(a);
// URL.revokeObjectURL(url);
export const toastDisplay = (result) => {
  if (result?.status === 200) {
    toast.success(result?.message)
  } else if (result?.status === 400) {
    if (result?.message) {
      errorToast(JSON.stringify(result?.message))
    } else {
      errorToast(JSON.stringify(result?.errors))
    }
  } else if (result?.status === 404) {
    errorToast(JSON.stringify(result?.message))
  } else if (result?.Status === 500) {
    errorToast(JSON.stringify(result?.Message))
  } else {
    errorToast(result?.message)
  }
}
export const textAreaLength = 2000

export const selfApproveLineItemWarningMsg = "Are you sure you want to Self Approve this item ?"
export const closeLineItemWarningMsg = "Are you sure you want to Close this item ?"
export const rejectRecordsWarningMsg = "Are you sure you want to Reject this Document ?"
export const imageWarningMsg = "Are you sure you want to Upload this Image ?"
export const isOutOfOfficeWarningMsg = "Are you sure you want to Change Out Of Office ?"
export const isOutOfOfficeForceWarningMsg = "Are you sure you want to Forcefully Change Out Of Office ?"
export const deleteWarningMsg = "Are you sure you want to delete this item ?"

export const SeedingCommonCustomerType = "Common"



export const removeDuplicates = (array, key) => {
  return array.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t[key] === item[key])
  );
};

export const imageLogin = (array, key) => {

  if (array.length > 0) {
    let FIleURL = "";
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      FIleURL = process.env.REACT_APP_IMAGE_BASE_URL;
    }
    return FIleURL + array?.find((item) => item.sequenceNo === key).filePath;
  } else {
    return "";
  }
};

export const userRights = (menuArray, moduleName, permissionName) => {
  // console.log(menuArray, moduleName, permissionName)
  let isAllow = false;
  if (moduleName === "Stand Alone DIB") {
    if (permissionName === "Add") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName)?.isAddAllowed
    } else if (permissionName === "Edit") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName)?.isEditAllowed
    } else if (permissionName === "Delete") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName)?.isDeleteAllowed
    } else if (permissionName === "AuthorizedEdit") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName)?.isEditAllowed
    } else if (permissionName === "Grant") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName)?.ifAccessGranted
    }
  } else {
    if (permissionName === "Add") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName && item.link !== "")?.isAddAllowed
    } else if (permissionName === "Edit") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName && item.link !== "")?.isEditAllowed
    } else if (permissionName === "Delete") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName && item.link !== "")?.isDeleteAllowed
    } else if (permissionName === "AuthorizedEdit") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName && item.link !== "")?.isEditAllowed
    } else if (permissionName === "Grant") {
      isAllow = menuArray?.find((item) => item.moduleName === moduleName && item.link !== "")?.ifAccessGranted
    }
  }
  if (isAllow === undefined) {
    isAllow = false;
  }
  return isAllow;
};
export const CommonExcelExportIgnoreFields = [
  "id",
  "masterRegionId",
  "masterCountryId",
  "masterStateId",
  "masterDistrictId",
  "masterCityId",
  "regionList",
  "branchList",
  "salesOfficeList",
  "regionIdList",
  "branchIdList",
  "salesOfficeIdList",
  "masterDesignationId",
  "actualDesignationId",
  "quotationApprovalUserId",
  "quotationApprovalUser",
  "customerApprovalUserId",
  "customerApprovalUser",
  "paymentTypeApprovalUserId",
  "paymentTypeApprovalUser",
  "disassemblyApprovalUserId",
  "disassemblyApprovalUser",
  "focApprovalUserId",
  "focApprovalUser",
  "flowNextUserId",
  "flowNextUser",
  "outOfOfficeUserId",
  "outOfOfficeUser",
  "isCOPSMainUser",
  "isCOPSOutOfOffice",
  "maxLoadPerDay",
  "totalCapacity",
  "priorityOtherBranch",
  "copsNextUser",
  "copsNextUserId",
  "masterBranchId",
  "masterDepartmentId",
  "masterSubDepartmentId",
  "masterEmployeeId",
  "masterPaymentTermId",
  "modulesId",
  "masterAmendmentTypeId",
  "createdBy",
  "modifiedBy",
  "masterAttachmentTypeId",
  "masterComplaintTypeId",
  "masterPlantId",
  "masterDeliveryTermId",
  "masterFrieghtTermId",
  "finalApprovalDesignationID",
  "masterApprovalLimits",
  "configureFinalApprovalId",
  "attachments",
  "isInbox",
  "isOutbox",
  "isDelayinFlow",
  "isActive",
  "isDelete",
  "createdDate",
  "modifiedDate",
];

export const ExportExcelFile = (formData, fileName) => {
  if (typeof formData === "string") {
    try {
      formData = JSON.parse(formData)
    } catch { }
  }
  const KeyToIgnore = CommonExcelExportIgnoreFields;
  const restColumns = Object.keys(formData[0]).filter(
    (column) => !KeyToIgnore.includes(column)
  );
  const wb = XLSX.utils.book_new();

  const rearrangedColumns = [...restColumns]; // darpan said 'id' remove from the excel

  // Create a worksheet with the extracted data
  // const wsData = formData.map(item => {
  const wsData = formData
    .sort((a, b) => a.id - b.id)
    .map((item) => {
      const rowData = {};
      rearrangedColumns.forEach((column) => {
        if (JsonData.hasOwnProperty(column)) {
          rowData[JsonData[column]] = item[column];
        } else {
          rowData[column] = item[column];
        }
      });
      return rowData;
    });

  // const ws = XLSX.utils.json_to_sheet([{}], { header: rearrangedColumns }); // create an empty row with headers
  const ws = XLSX.utils.json_to_sheet(wsData); // create an empty row with headers

  // // Add the rest of the columns dynamically
  XLSX.utils.sheet_add_json(ws, wsData, { skipHeader: true, origin: `A2` });

  // // Add the worksheet to the workbook
  XLSX.utils.book_append_sheet(wb, ws, "Data");

  XLSX.writeFile(wb, `${fileName}.xlsx`);

}

export const replaceEmptyWithNull = (data) => {
  if (Array.isArray(data)) {
    return data.map(item => replaceEmptyWithNull(item));
  }

  if (data !== null && typeof data === "object") {
    return Object.keys(data).reduce((acc, key) => {
      const value = data[key];

      acc[key] =
        value === "" ? null :
          typeof value === "object"
            ? replaceEmptyWithNull(value)
            : value;

      return acc;
    }, {});
  }

  return data;
};

export const CurrencyFormat = (inputString) => {
  const number = parseFloat(inputString);
  // Convert the number to a string
  const numberString = number.toFixed(2);

  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = numberString.split('.');

  // Use regular expression to add commas for lakhs and crores
  const formattedIntegerPart = integerPart.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  let formattedNumber = 0;
  if (decimalPart > 0) {
    formattedNumber = formattedIntegerPart + '.' + decimalPart
  } else {
    formattedNumber = formattedIntegerPart
  }
  return formattedNumber;
}

export const IsFilterPresent = (Key, Array) => {
  if (Array) {
    let Check = Array.find((item) => item.module === Key)
    if (Check) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export const FilterOldData = (Key, Array) => {
  if (Array) {
    let Check = Array.find((item) => item.module === Key)
    if (Check) {
      return Check
    } else {
      return false
    }
  } else {
    return false
  }
}

export const RemoveFilterReq = (Key, Array) => {
  if (Array) {
    let Check = Array.filter((item) => item.module !== Key)
    return Check
  } else {
    return false
  }
}

export const UpdateFilterReq = (Key, Val, Array) => {
  if (Array) {
    let Check = Array.filter((item) => item.module !== Key)
    Check.push({ module: Key, value: Val })
    return Check
  } else {
    return false
  }
}

export const createTimeArray = (startHour, endHour, intervalMinutes) => {
  const timeSlots = [];
  let currentTime = new Date();
  currentTime.setHours(startHour, 0, 0, 0);

  const endTime = new Date();
  endTime.setHours(endHour, 0, 0, 0);

  while (currentTime <= endTime) {
    const hours = currentTime.getHours();
    const minutes = currentTime.getMinutes();
    const formattedHours = hours % 12 || 12;
    const formattedTime = `${formattedHours < 10 ? '0' + formattedHours : formattedHours}:${minutes === 0 ? '00' : minutes} ${hours < 12 ? 'AM' : 'PM'}`;
    timeSlots.push(formattedTime);
    currentTime.setMinutes(currentTime.getMinutes() + intervalMinutes);
  }

  return timeSlots;
};

export const PageSizeOptionArr = [
  {
    text: "10",
    page: 10,
  },
  {
    text: "25",
    page: 25,
  },
  {
    text: "30",
    page: 30,
  },
  {
    text: "50",
    page: 50,
  },
  {
    text: "100",
    page: 100,
  },
];